import { ModalContent as OriginalModalContent } from 'components/modal';

import { ADDRESS_MODAL_WIDTH_DESKTOP } from './constants';

export const ModalContent = OriginalModalContent.withConfig({
  width: { base: 'full', md: ADDRESS_MODAL_WIDTH_DESKTOP },
  paddingX: { base: '$8', md: '$0' },
  alignSelf: 'center',
});
